/**
 * A hero banner.
 *
 * -- Props --
 * | Name       | Type    | Required  | Default Value | Description
 * |------------|---------|-----------|---------------|---------------
 * | id         | string  | false     | null          | An id to apply to this component.
 * | className  | string  | false     | ""            | Additional classes to apply to this component.
 */
export const Hero = (props) => {
  return (
    <section id={props.id || null} className={`hero${props.className ? " " + props.className : ""}`}>
      {props.children}
    </section>
  );
}

export default Hero;